import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "./environment.service";
import {
    ActionResult,
    LeagueCompetitorStanding,
    LeagueStandingsFilter,
    LeagueStandingsMeta, PagedFilter,
} from "@model";
import {map, Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class LeagueStandingsService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

    getStandingsMeta(leagueId: number, isAdmin = false): Observable<LeagueStandingsMeta[]> {
        const url = isAdmin
            ? `${this.environmentService.getApiUrl()}/api/league/standings/${leagueId}/meta`
            : `${this.environmentService.getApiUrl()}/api/public/league/standings/${leagueId}/meta`;
        return this.http.get<ActionResult<LeagueStandingsMeta[]>>(url).pipe(
            map(res => res?.result ?? [])
        );
    }

    getStandings(leagueId: number, filter: PagedFilter<LeagueStandingsFilter>, isAdmin = false): Observable<LeagueCompetitorStanding[]> {
        const url = isAdmin
            ? `${this.environmentService.getApiUrl()}/api/league/standings/${leagueId}`
            : `${this.environmentService.getApiUrl()}/api/public/league/standings/${leagueId}`;
        return this.http.post<ActionResult<LeagueCompetitorStanding[]>>(url, filter).pipe(
            map(res => res?.result ?? [])
        );
    }
}